import { SymbolEntity } from 'core/models';
import { inject, injectable } from 'inversify';
import { HttpClientService } from './http-client.service';

const API_BASE = '/api';

@injectable()
export class SymbolsService {
  @inject(HttpClientService)
  private httpClient: HttpClientService;

  private cache: Record<string, SymbolEntity>;

  public getAllSymbols(): Promise<SymbolEntity[]> {
    return this.httpClient.get(API_BASE + '/v1/symbols');
  }

  public cacheSymbols(): Promise<void> {
    return this.getAllSymbols().then((symbols) => {
      this.cache = symbols.reduce((target, symbol) => {
        target[symbol.id] = symbol;
        return target;
      }, {});
    });
  }

  public getSymbolById(id: string): SymbolEntity {
    return this.cache[id] || ({} as SymbolEntity);
  }

  public searchSymbols(text: string): SymbolEntity[] {
    text = text.toLowerCase();
    return Object.values(this.cache).filter(
      (symbol) => symbol.code.toLowerCase().indexOf(text) === 0 || symbol.issuerName.toLowerCase().indexOf(text) === 0
    );
  }
}
